module.exports = __webpack_public_path__ + "img/SWP_Shield_08 (1).8137b53e.png";